import { UsergroupAddOutlined } from '@ant-design/icons'
import React from 'react'

export default function ChartSection() {
    return (
        <div style={{
            border: '1px solid #e2e4e9',
            borderRadius: 6,
            marginBottom: 16
        }}>
            <div
                style={{
                    borderBottom: '1px solid #e2e4e9',
                    padding: 8,
                    background: '#f0f2f44d',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                }}
            >
                <UsergroupAddOutlined />
                <span style={{
                    fontWeight: 600,
                    fontFamily: 'tradeGothic',
                    fontSize: 14
                }}>
                    Charts
                </span>
            </div>
            <div style={{padding: 8}}>
                All charts and files associated with both profiles are merged into the surviving profile.
            </div>
        </div>)
}
